import React, { FC } from 'react'

// import Map, { Source, Layer } from 'react-map-gl'
import 'mapbox-gl/dist/mapbox-gl.css'
import { AdvancedMarker, Map } from '@vis.gl/react-google-maps'
import { MAP_ID } from 'src/helpers/mapConfig'
import { useMapColorScheme } from '@hooks/useMapColorScheme'
// import { mapboxToken } from 'src/components/pages/announcement/sections/property-details/PropertyDetails'

interface IMapView {
  latitude: number
  longitude: number
}

const MapView: FC<IMapView> = ({ latitude, longitude }) => {
  const colorScheme = useMapColorScheme()
  return (
    <section className="mt-5 w-full rounded-lg overflow-hidden">
      <Map
        gestureHandling={'greedy'}
        disableDefaultUI
        style={{ width: '100%', height: '13.9375rem' }}
        defaultCenter={{ lat: latitude, lng: longitude }}
        defaultZoom={15}
        mapId={MAP_ID}
        colorScheme={colorScheme}
      >
        <AdvancedMarker position={{ lat: latitude, lng: longitude }} />
      </Map>
    </section>
  )
}

export default MapView
